import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { useEffect } from 'react';

const ThemeProvider = ({ theme, children }) => {
  useEffect(() => {
    const body = document.body;
    if (theme.palette.mode === 'dark') {
      body.classList.add('dark');
    } else {
      body.classList.remove('dark');
    }

    return () => {
      body.classList.remove('dark');
    };
  }, [theme.palette.mode]);

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
